/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "eilen",
        "-2": "toissa päivänä",
        "0": "tänään",
        "1": "huomenna",
        "2": "ylihuomenna",
        "future": {
          "one": "{0} päivän päästä",
          "other": "{0} päivän päästä"
        },
        "past": {
          "one": "{0} päivä sitten",
          "other": "{0} päivää sitten"
        }
      },
      "day-narrow": {
        "-1": "eilen",
        "-2": "toissap.",
        "0": "tänään",
        "1": "huom.",
        "2": "ylihuom.",
        "future": {
          "one": "{0} pv päästä",
          "other": "{0} pv päästä"
        },
        "past": {
          "one": "{0} pv sitten",
          "other": "{0} pv sitten"
        }
      },
      "day-short": {
        "-1": "eilen",
        "-2": "toissap.",
        "0": "tänään",
        "1": "huom.",
        "2": "ylihuom.",
        "future": {
          "one": "{0} pv päästä",
          "other": "{0} pv päästä"
        },
        "past": {
          "one": "{0} pv sitten",
          "other": "{0} pv sitten"
        }
      },
      "hour": {
        "0": "tämän tunnin aikana",
        "future": {
          "one": "{0} tunnin päästä",
          "other": "{0} tunnin päästä"
        },
        "past": {
          "one": "{0} tunti sitten",
          "other": "{0} tuntia sitten"
        }
      },
      "hour-narrow": {
        "0": "tunnin sisällä",
        "future": {
          "one": "{0} t päästä",
          "other": "{0} t päästä"
        },
        "past": {
          "one": "{0} t sitten",
          "other": "{0} t sitten"
        }
      },
      "hour-short": {
        "0": "tunnin sisällä",
        "future": {
          "one": "{0} t päästä",
          "other": "{0} t päästä"
        },
        "past": {
          "one": "{0} t sitten",
          "other": "{0} t sitten"
        }
      },
      "minute": {
        "0": "tämän minuutin aikana",
        "future": {
          "one": "{0} minuutin päästä",
          "other": "{0} minuutin päästä"
        },
        "past": {
          "one": "{0} minuutti sitten",
          "other": "{0} minuuttia sitten"
        }
      },
      "minute-narrow": {
        "0": "minuutin sisällä",
        "future": {
          "one": "{0} min päästä",
          "other": "{0} min päästä"
        },
        "past": {
          "one": "{0} min sitten",
          "other": "{0} min sitten"
        }
      },
      "minute-short": {
        "0": "minuutin sisällä",
        "future": {
          "one": "{0} min päästä",
          "other": "{0} min päästä"
        },
        "past": {
          "one": "{0} min sitten",
          "other": "{0} min sitten"
        }
      },
      "month": {
        "-1": "viime kuussa",
        "0": "tässä kuussa",
        "1": "ensi kuussa",
        "future": {
          "one": "{0} kuukauden päästä",
          "other": "{0} kuukauden päästä"
        },
        "past": {
          "one": "{0} kuukausi sitten",
          "other": "{0} kuukautta sitten"
        }
      },
      "month-narrow": {
        "-1": "viime kk",
        "0": "tässä kk",
        "1": "ensi kk",
        "future": {
          "one": "{0} kk päästä",
          "other": "{0} kk päästä"
        },
        "past": {
          "one": "{0} kk sitten",
          "other": "{0} kk sitten"
        }
      },
      "month-short": {
        "-1": "viime kk",
        "0": "tässä kk",
        "1": "ensi kk",
        "future": {
          "one": "{0} kk päästä",
          "other": "{0} kk päästä"
        },
        "past": {
          "one": "{0} kk sitten",
          "other": "{0} kk sitten"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "viime neljännesvuonna",
        "0": "tänä neljännesvuonna",
        "1": "ensi neljännesvuonna",
        "future": {
          "one": "{0} neljännesvuoden päästä",
          "other": "{0} neljännesvuoden päästä"
        },
        "past": {
          "one": "{0} neljännesvuosi sitten",
          "other": "{0} neljännesvuotta sitten"
        }
      },
      "quarter-narrow": {
        "-1": "viime nelj.",
        "0": "tänä nelj.",
        "1": "ensi nelj.",
        "future": {
          "one": "{0} nelj. päästä",
          "other": "{0} nelj. päästä"
        },
        "past": {
          "one": "{0} nelj. sitten",
          "other": "{0} nelj. sitten"
        }
      },
      "quarter-short": {
        "-1": "viime neljänneksenä",
        "0": "tänä neljänneksenä",
        "1": "ensi neljänneksenä",
        "future": {
          "one": "{0} neljänneksen päästä",
          "other": "{0} neljänneksen päästä"
        },
        "past": {
          "one": "{0} neljännes sitten",
          "other": "{0} neljännestä sitten"
        }
      },
      "second": {
        "0": "nyt",
        "future": {
          "one": "{0} sekunnin päästä",
          "other": "{0} sekunnin päästä"
        },
        "past": {
          "one": "{0} sekunti sitten",
          "other": "{0} sekuntia sitten"
        }
      },
      "second-narrow": {
        "0": "nyt",
        "future": {
          "one": "{0} s päästä",
          "other": "{0} s päästä"
        },
        "past": {
          "one": "{0} s sitten",
          "other": "{0} s sitten"
        }
      },
      "second-short": {
        "0": "nyt",
        "future": {
          "one": "{0} s päästä",
          "other": "{0} s päästä"
        },
        "past": {
          "one": "{0} s sitten",
          "other": "{0} s sitten"
        }
      },
      "week": {
        "-1": "viime viikolla",
        "0": "tällä viikolla",
        "1": "ensi viikolla",
        "future": {
          "one": "{0} viikon päästä",
          "other": "{0} viikon päästä"
        },
        "past": {
          "one": "{0} viikko sitten",
          "other": "{0} viikkoa sitten"
        }
      },
      "week-narrow": {
        "-1": "viime vk",
        "0": "tällä vk",
        "1": "ensi vk",
        "future": {
          "one": "{0} vk päästä",
          "other": "{0} vk päästä"
        },
        "past": {
          "one": "{0} vk sitten",
          "other": "{0} vk sitten"
        }
      },
      "week-short": {
        "-1": "viime vk",
        "0": "tällä vk",
        "1": "ensi vk",
        "future": {
          "one": "{0} vk päästä",
          "other": "{0} vk päästä"
        },
        "past": {
          "one": "{0} vk sitten",
          "other": "{0} vk sitten"
        }
      },
      "year": {
        "-1": "viime vuonna",
        "0": "tänä vuonna",
        "1": "ensi vuonna",
        "future": {
          "one": "{0} vuoden päästä",
          "other": "{0} vuoden päästä"
        },
        "past": {
          "one": "{0} vuosi sitten",
          "other": "{0} vuotta sitten"
        }
      },
      "year-narrow": {
        "-1": "viime v",
        "0": "tänä v",
        "1": "ensi v",
        "future": {
          "one": "{0} v päästä",
          "other": "{0} v päästä"
        },
        "past": {
          "one": "{0} v sitten",
          "other": "{0} v sitten"
        }
      },
      "year-short": {
        "-1": "viime v",
        "0": "tänä v",
        "1": "ensi v",
        "future": {
          "one": "{0} v päästä",
          "other": "{0} v päästä"
        },
        "past": {
          "one": "{0} v sitten",
          "other": "{0} v sitten"
        }
      }
    },
    "locale": "fi"
  });
}